import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["select", "approveButton", "approveHint"];
  static values = {
    url: String,
    minQueryLength: { type: Number, default: 2 },
  };

  connect() {
    this.initTomSelect();
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }

  initTomSelect() {
    const url = this.urlValue;
    const initialValue = this.selectTarget.value;
    let initialOption = null;

    if (initialValue) {
      const selectedOption = this.selectTarget.querySelector(
        `option[value='${initialValue}']`,
      );
      if (selectedOption) {
        const address = selectedOption.dataset.address || "";
        const apn = selectedOption.dataset.apn || "";
        initialOption = {
          id: initialValue,
          apn: apn,
          address: address,
          display: selectedOption.text,
        };
      }
    }

    this.tomSelect = new TomSelect(this.selectTarget, {
      valueField: "id",
      labelField: "display",
      searchField: ["apn", "address"],
      placeholder: "Search by APN or address...",
      options: initialOption ? [initialOption] : [],
      shouldLoad: (query) => query.length >= this.minQueryLengthValue,
      loadThrottle: 300,
      load: (query, callback) => {
        if (!query.length || query.length < this.minQueryLengthValue) {
          callback([]);
          return;
        }

        fetch(`${url}?q=${encodeURIComponent(query)}`, {
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            callback(data);
          })
          .catch(() => {
            callback([]);
          });
      },
      render: {
        option: (data, escape) => {
          return `<div class="py-2">
            <div class="fw-bold">${escape(data.address)}</div>
            <div class="text-muted small">${escape(data.apn || "")}</div>
          </div>`;
        },
        item: (data, escape) => {
          return `<div class="py-1 d-flex flex-column align-items-start">
            <div class="fw-bold">${escape(data.address)}</div>
            <div class="text-muted small">${escape(data.apn || "")}</div>
          </div>`;
        },
        no_results: () => {
          return '<div class="no-results p-2 text-muted">No properties found</div>';
        },
      },
      onChange: (value) => {
        this.handleChange(value);
      },
    });

    if (initialValue) {
      this.tomSelect.setValue(initialValue);
    }
  }

  handleChange(value) {
    if (!this.hasApproveButtonTarget || !this.hasApproveHintTarget) return;

    if (value) {
      this.approveButtonTarget.disabled = false;
      this.approveHintTarget.classList.add("d-none");
    } else {
      this.approveButtonTarget.disabled = true;
      this.approveHintTarget.classList.remove("d-none");
    }
  }
}
